export default __webpack_public_path__ + "static/media/corrugated-iron-front.a484e2e9.png";